export default function modifyCSS(dom, css) {
    if (dom) {
        for (var key in css) {
            if (css.hasOwnProperty(key)) {
                dom.style[key] = css[key];
            }
        }
    }
    return dom;
}
//# sourceMappingURL=modify-css.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/dom-util/esm/modify-css.js
// module id = null
// module chunks = 